import React from "react";

const ErrorAlert = ({ onClose, error, isServerError, showBtn = true }) => {
  return (
    <div className="error-alert">
      <h1 className="title">{isServerError ? "Something went wrong!" : ""}</h1>
      <p className="description">{error}</p>
      {showBtn && (
        <button className="action" onClick={onClose}>
          Ok
        </button>
      )}
    </div>
  );
};

export default ErrorAlert;
